import { create } from "zustand";

export const useBooking = create((set) => ({
    open: false,
    openBooking: () => set({ open: true }),
    closeBooking: () => set({ open: false }),
}));
